import { render } from "./OfferThermalChannel.vue?vue&type=template&id=02229cad"
import script from "./OfferThermalChannel.vue?vue&type=script&lang=js"
export * from "./OfferThermalChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__